// День API (`YYYY-MM-DD`, UTC) → дата для `Intl.DateTimeFormat` с `timeZone: "UTC"`.
export const dayDate = (day: string): Date => new Date(`${day}T00:00:00Z`);
